import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Globe, MapPin } from 'lucide-react';
import img1 from "../components/images/anıtkabir.webp"
import img2 from "../components/images/hacıbayram.webp"
import img3 from "../components/images/milletbahcesi.webp"

// Sanal tur kartları için sahte veriler
const mockVirtualTours = [
    {
        id: "1",
        slug: "anitkabir",
        title: "Anıtkabir",
        description: "Türkiye Cumhuriyeti'nin kurucusu Mustafa Kemal Atatürk'ün ebedi istirahatgahı olan Anıtkabir'i sanal olarak keşfedin.",
        imageUrl: img1,
    },
    {
        id: "2",
        slug: "hacibayram",
        title: "Hacı Bayram Veli Camii",
        description: "Ankara'nın tarihi ve manevi merkezlerinden biri olan Hacı Bayram Veli Camii'nin atmosferini sanal turla deneyimleyin.",
        imageUrl: img2,
    },
    {
        id: "3",
        slug: "baskent-milletbahcesi",
        title: "Başkent Millet Bahçesi Sanal Turu",
        description: "Ankara'nın merkezinde bulunan bu millet bahçesi...",
        imageUrl: img3,
    },
];

const VirtualTourPage = () => {
    const [tours, setTours] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Mock veri çekme işlemini simüle ediyoruz
        setLoading(true);
        setError(null);
        setTimeout(() => {
            try {
                if (mockVirtualTours.length > 0) {
                    setTours(mockVirtualTours);
                } else {
                    setError("Sanal tur verisi bulunamadı.");
                }
            } catch (err) {
                setError("Veri yüklenirken bir sorun oluştu.");
            } finally {
                setLoading(false);
            }
        }, 800);
    }, []);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen bg-gray-900">
                <div className="w-16 h-16 border-4 border-t-4 border-indigo-500 rounded-full animate-spin"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col justify-center items-center h-screen bg-gray-900 text-red-500">
                <p className="text-xl mb-4">{error}</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-900 text-white font-inter py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                {/* Sayfa Başlığı ve Açıklama */}
                <header className="text-center mb-12">
                    <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 mb-4 drop-shadow-md">
                        Sanal Turlarımız
                    </h1>
                    <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                        Mekânname'nin sanal tur teknolojisi ile tarihi mekanları üç boyutlu olarak keşfedin.
                    </p>
                </header>

                {/* Sanal Tur Kartları */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {tours.map(tour => (
                        <Link
                            key={tour.id}
                            to={`/virtual-tour/${tour.slug}`}
                            className="group relative block rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
                        >
                            {/* Kart Görseli */}
                            <img
                                src={tour.imageUrl}
                                alt={tour.title}
                                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                            />

                            {/* Kart İçeriği */}
                            <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent p-6 flex flex-col justify-end">
                                <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-amber-400 transition-colors duration-200">
                                    {tour.title}
                                </h3>
                                <p className="text-gray-300 text-sm">
                                    {tour.description}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VirtualTourPage;
